import { Routes, Route, Link, Navigate } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { DevToolsPage } from "./pages/DevTools";
import { QuizPlayPage } from "./pages/QuizPlayPage";
import { QuizStudioPage } from "./pages/QuizStudioPage";
import { MyQuizzesPage } from "./pages/MyQuizzesPage";
import { ProgressPage } from "./pages/ProgressPage";
import { StudyDashboardPage } from "./pages/StudyDashboardPage";
import { AuthPage } from "./pages/AuthPage";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { SharedQuizPage } from "./pages/SharedQuizPage";
import { JourneyBuilderPage } from "./pages/JourneyBuilderPage";
import { MyJourneysPage } from "./pages/MyJourneysPage";
import { JourneyDetailPage } from "./pages/JourneyDetailPage";
import { BrowseGeoJSONPage } from "./pages/BrowseGeoJSONPage";
import { GeoJSONPreviewPage } from "./pages/GeoJSONPreviewPage";
import { GrassyJSONDemoPage } from "./pages/GrassyJSONDemoPage";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen">
        <Toaster />

      {/* Dev tools link (only in dev mode) */}
      {import.meta.env.DEV && (
        <div className="fixed bottom-4 right-4 z-50">
          <Link
            to="/dev"
            className="px-4 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-lg hover:bg-gray-800 transition-colors"
          >
            🛠️ Dev Tools
          </Link>
        </div>
      )}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/geojson/browse" element={<BrowseGeoJSONPage />} />
        <Route path="/geojson/:id" element={<GeoJSONPreviewPage />} />
        <Route path="/quiz/play" element={<QuizPlayPage />} />
        <Route path="/quiz/studio" element={<QuizStudioPage />} />
        <Route path="/quiz/my-quizzes" element={<MyQuizzesPage />} />
        <Route path="/quiz/shared/:slug" element={<SharedQuizPage />} />
        <Route path="/progress" element={<ProgressPage />} />
        {/* Redirects for old URLs */}
        <Route path="/knowledge" element={<Navigate to="/progress" replace />} />
        <Route path="/stats" element={<Navigate to="/progress" replace />} />
        <Route path="/study" element={<StudyDashboardPage />} />
        <Route path="/journeys/builder" element={<JourneyBuilderPage />} />
        <Route path="/journeys/my-journeys" element={<MyJourneysPage />} />
        <Route path="/journeys/:journeyId" element={<JourneyDetailPage />} />
        {import.meta.env.DEV && <Route path="/dev" element={<DevToolsPage />} />}
        {import.meta.env.DEV && <Route path="/dev/grassyjson" element={<GrassyJSONDemoPage />} />}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
    </AuthProvider>
  );
}

function NotFoundPage() {
  return (
    <div className="container mx-auto p-8">
      <h1 className="text-4xl font-bold mb-4">404 - Not Found</h1>
      <p className="text-muted-foreground">The page you're looking for doesn't exist.</p>
      <Link to="/" className="text-primary hover:underline mt-4 inline-block">
        ← Back to home
      </Link>
    </div>
  );
}

export default App;
